import React, { useContext, useState, useEffect } from "react";

import { json, Link } from "react-router-dom";

import { useContainerPrice } from "../../../../hooks/useContainerPrice";
import { AppContext } from "../../../../providers/appProvider";
import ErrorModal from "../../../UI/ErrorModal/ErrorModal";
import Pagination from "../../../UI/Pagination/Pagination";
import ContainerPriceDeleteModal from "../Delete/Delete";
import ContainerPriceEditModal from "../Edit/Edit";
import Active from "../Active/Active";
import AddContainerPrice from "../Add/Add";
import tbl from "../../../../assets/Style/Table.module.css";
import Select from "react-select";
import DateSelect from "../../../UI/Inputs/DateSelect";
import Excel from "../../../../assets/Icon/Excel";
import Users from "../../../../assets/Icon/Users";
import Ship from "../../../../assets/Icon/Ship";
import Plus from "../../../../assets/Icon/Plus";
import Modal from "../../../UI/Modal/Modal";

import cl from "./List.module.css";
import { selectStyle } from "./selectStyle";
import AddOne from "../AddOne/Add";
import { useTranslation } from 'react-i18next';

const ContainerPriceList = () => {
  const {t} = useTranslation();
  
  const { ContainerPriceService } = useContainerPrice(50, true);
  const { appState, app } = useContext(AppContext);
  const [currentTab, setCurrentTab] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [existingContainerIds, setExistingContainerIds] = useState([]);

  const initialTypeOptions = [
        { value: 0, label: 'საზღვაო' },
        { value: 1, label: 'სახმელეთო' },
        { value: 2, label: 'სარკინიგზო' },
        { value: 3, label: 'საჰაერო' },
  ];

  const marines = appState.marines.map((marine) => ({
    value: marine.id,
    label: marine.name,
  }));
  const [receivers, setReceivers] = useState([]);
  const [senders, setSenders] = useState([]);

  useEffect(() => {
    const getCountryName = (countryId) => {
      const country = appState.countries.find(
        (country) => country.id === countryId
      );
      return country ? country.name : "";
    };

    const receiverCities = Array.from(
      new Set(appState.prices.map((item) => item.reciever_city?.id))
    ).map((id) => {
      const city = appState.prices.find(
        (item) => item.reciever_city?.id === id
      )?.reciever_city;
      return {
        value: city.id,
        label: `${getCountryName(city.country_id)} ${city.name}`,
      };
    });
    setReceivers(receiverCities);

    const senderCities = Array.from(
      new Set(appState.prices.map((item) => item.sender_city?.id))
    ).map((id) => {
      const city = appState.prices.find(
        (item) => item.sender_city?.id === id
      )?.sender_city;
      return {
        value: city.id,
        label: `${getCountryName(city.country_id)} ${city.name}`,
      };
    });
    setSenders(senderCities);
  }, [appState.prices, appState.countries]);

  useEffect(() => {
    ContainerPriceService.fetchList();
  }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    const intValue = parseInt(value, 10);

    if (!isNaN(intValue)) {
      ContainerPriceService.setFilter({
        ...ContainerPriceService.filter,
        [name]: intValue,
      });
    } else {
      ContainerPriceService.setFilter({
        ...ContainerPriceService.filter,
        [name]: null,
      });
    }
  };

  const saveContainerIds = async () => {
    const dynamicInputs = document.querySelectorAll('#dynamicInputs input');
    
    const allInputValues = [
      ...Array.from(dynamicInputs).map(input => input.value.trim())
    ].filter(value => value !== '');
    
    const selectedRow = document.querySelector('tr.selected');
    if (!selectedRow) {
      console.log('No row selected.');
      return;
    }
    
    const containerPriceId = selectedRow.querySelector(`.${cl.id}`).textContent;
    
    const originalIds = JSON.parse(
      selectedRow.dataset.containerIds || '[]' 
    );
    
    allInputValues.forEach(el => {
      if(originalIds.includes(el)) {
        app.setError('დაფიქსირდა შეცდომა: კონტეინერის აიდი განმეორებულია!');
        return;
      }
    })
    
    const newIds = allInputValues.filter(id => 
      !originalIds.includes(id)
    );
    
    if (newIds.length === 0) {
      app.setError('დაფიქსირდა შეცდომა: არ არის შეყვანილი კონტეინერის ID!');
      return;
    }
    
    try {
      const statuses = newIds.map(id => ({ id, status: "pending" }));
      
      const result = await ContainerPriceService.addContainerStatuses(
        parseInt(containerPriceId),
        statuses
      );
      
      console.log("Added statuses:", result);
      selectedRow.dataset.containerIds = JSON.stringify([...originalIds, ...newIds]);
      dynamicInputs.forEach(input => input.value = '');
    } catch (error) {
      console.error("Save failed:", error);
    }
    setIsModalOpen(false);
    ContainerPriceService.fetchList();
    ContainerPriceService.fetchList().then(data => console.log(data))
  };

  const renumberInputs = () => {
    const inputs = document.querySelectorAll('#dynamicInputs > div');
    inputs.forEach((wrapper, index) => {
      const numberSpan = wrapper.querySelector('.input-number');
      if (numberSpan) {
        numberSpan.textContent = `${index + 1}.`;
      }
    });
  };

  const customFilers = [
    { value: 1, label: "აქტიური" },
    { value: 2, label: "არქივი" },
  ];

  const websites = appState.websites.map((website) => ({
    value: website.id,
    label: website.name,
  }));

  const onChangeTab = (val) => {
    setCurrentTab(val.value);
    switch (val.value) {
      case 1:
        ContainerPriceService.setFilter((prevState) => ({
          ...prevState,
          is_active: true,
        }));
        break;
      case 2:
        ContainerPriceService.setFilter((prevState) => ({
          ...prevState,
          is_active: false,
        }));
        break;
      default:
        ContainerPriceService.setFilter((prevState) => ({
          ...prevState,
          is_active: true,
        }));
    }
  };

  const hanldeCreatedAtMin = (date) => {
    ContainerPriceService.setFilter({
      ...ContainerPriceService.filter,
      created_at_min: date ? date : "",
    });
  };

  const hanldeCreatedAtMax = (date) => {
    ContainerPriceService.setFilter({
      ...ContainerPriceService.filter,
      created_at_max: date ? date : "",
    });
  };

  const openAdd = (containerPrice) => {
    // setValidates({})\
    console.log(containerPrice.container_ids)
    setExistingContainerIds(containerPrice.container_ids)
    setIsModalOpen(true);
    // setIsFirstValidated(false)
    // setNewAgent(agentResetData)
  };
  console.log(ContainerPriceService.items)
  const formatDate = (dateString) => {
    const createdAtDate = new Date(dateString);

    const months = [
      "იან",
      "თებ",
      "მარ",
      "აპრ",
      "მაი",
      "ივნ",
      "ივლ",
      "აგვ",
      "სექ",
      "ოქტ",
      "ნოე",
      "დეკ",
    ];

    const day = createdAtDate.getDate();
    const month = months[createdAtDate.getMonth()];
    const year = createdAtDate.getFullYear();
    const hours = createdAtDate.getHours().toString().padStart(2, "0");
    const minutes = createdAtDate.getMinutes().toString().padStart(2, "0");

    return `${day} ${month} ${year}`;
  };

  const downloadExcel = () => {
    ContainerPriceService.downloadExcel();
  };

  const getTypeLabel = (typeId) => {
    const typeOption = initialTypeOptions.find(
      (option) => option.value === typeId
    );
    return typeOption ? typeOption.label : "";
  };

  return (
    <div>
      <div className={cl.headMain}>
        <h1>{t('Transportation')}</h1>

        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          {app.hasPermission("SHIPPER_PAGE_SHOW") && (
            <Link className={cl.Btn} to="/databases/shippers">
              <span className={cl.icon}>
                {" "}
                <Ship />
              </span>
              შიპერები
            </Link>
          )}
          {app.hasPermission("MARINE_LINE_PAGE_SHOW") && (
            <Link className={cl.Btn} to="/databases/marine_lines">
              <span className={cl.icon}>
                {" "}
                <Ship />
              </span>
              საზღვაო ხაზი
            </Link>
          )}

          {app.hasPermission("AGENTS_PAGE_SHOW") && (
            <Link className={cl.Btn} to="/databases/agents">
              <span className={cl.icon}>
                {" "}
                <Users />
              </span>
              აგენტები
            </Link>
          )}

          {app.hasPermission("CONTAINER_PRICE_UPLOAD") && (
            <>
              <AddOne ContainerPriceService={ContainerPriceService} />
            </>
          )}
        </div>
      </div>

      <div className={cl.searchBox}>
        <div
          className={cl.col}
          style={{ borderRight: "1px solid var(--border-color)", width: "35%" }}
        >
          <div className={cl.inBoxDate}>
            <div className={cl.dateGroup}>
              <DateSelect
                defDate={""}
                onChange={hanldeCreatedAtMin}
                placeholderText="თარიღი დან"
                popperClassName={cl.dataContainer}
                wrapperClassName={cl.dataContainer}
                className={cl.input}
                isClearable
              />
            </div>
          </div>
        </div>

        <div
          className={cl.col}
          style={{ borderRight: "1px solid var(--border-color)", width: "35%" }}
        >
          <div className={cl.inBoxDate}>
            <div className={cl.dateGroup}>
              <DateSelect
                defDate={""}
                onChange={hanldeCreatedAtMax}
                placeholderText="თარიღი მდე"
                popperClassName={cl.dataContainer}
                wrapperClassName={cl.dataContainer}
                className={cl.input}
                isClearable
              />
            </div>
          </div>
        </div>

        <div className={cl.col} style={{ width: "30%" }}>
          <Select
            styles={selectStyle}
            options={customFilers}
            value={customFilers.find((option) => option.value === currentTab)}
            onChange={onChangeTab}
          />
        </div>
      </div>

      <div
        className={tbl.table + " " + cl.table}
        style={{ height: "calc(100vh - 158px)", background: "white" }}
      >
        <table>
          <thead>
            <tr>
              <th className={cl.pad0}></th>
              <th className={cl.id}>ID</th>

              <th className={cl.pad0}>
                <Select
                  styles={selectStyle}
                  options={marines}
                  value={marines.find(
                    (option) =>
                      option.value ===
                      ContainerPriceService.filter.marine_line_id
                  )}
                  onChange={(selectedOption) => {
                    ContainerPriceService.setFilter((prevState) => ({
                      ...prevState,
                      marine_line_id: selectedOption ? selectedOption.value : 0,
                    }));
                  }}
                  isClearable
                  placeholder="საზღვაო ხაზი"
                />
              </th>

              <th>ტიპი</th>

              <th className={cl.pad0}>
                <Select
                  styles={selectStyle}
                  options={senders}
                  value={senders.find(
                    (option) =>
                      option.value ===
                      ContainerPriceService.filter.sender_city_id
                  )}
                  onChange={(selectedOption) => {
                    ContainerPriceService.setFilter((prevState) => ({
                      ...prevState,
                      sender_city_id: selectedOption ? selectedOption.value : 0,
                    }));
                  }}
                  isClearable
                  placeholder="ჩატვირთვის პორტი"
                />
              </th>
              <th className={cl.pad0}>
                <Select
                  styles={selectStyle}
                  options={receivers}
                  value={receivers.find(
                    (option) =>
                      option.value ===
                      ContainerPriceService.filter.reciever_city_id
                  )}
                  onChange={(selectedOption) => {
                    ContainerPriceService.setFilter((prevState) => ({
                      ...prevState,
                      reciever_city_id: selectedOption
                        ? selectedOption.value
                        : 0,
                    }));
                  }}
                  isClearable
                  placeholder="მიღების პორტი"
                />
              </th>

              <th className={cl.pad0}>
                <input
                  name="price"
                  className={cl.input}
                  placeholder="კომპანიის ფასი"
                  value={ContainerPriceService.filter.price}
                  onChange={handleInputChange}
                />
              </th>

              <th className={cl.pad0}>
                <input
                  name="price"
                  className={cl.input}
                  placeholder="კლიენტის ფასი"
                  value={ContainerPriceService.filter.price}
                  onChange={handleInputChange}
                />
              </th>

              <th>აგენტი</th>
              <th>დაწყება</th>
              <th>დასრულება</th>
              <th>შექმნა</th>
              <th>განახლება</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {ContainerPriceService.items.map((ContainerPrice) => (
              <tr key={ContainerPrice.id}
                onClick={(e) => {
                  document.querySelectorAll('tbody tr').forEach(row => row.classList.remove('selected'));
                  e.currentTarget.classList.add('selected');
                }}
              >
                <td>
                  <span onClick={() => openAdd(ContainerPrice)} className={cl.AddBtn}>
                    <span className={cl.icon}>
                      {" "}
                      <Plus />
                    </span>
                  </span>
                </td>
                <td className={cl.id}>{ContainerPrice.id}</td>
                <td> {ContainerPrice.marine_line?.name || ""} </td>
                <td>{getTypeLabel(ContainerPrice.type_id)}</td>

                <td>
                  {ContainerPrice.sender_country?.name || ""}{" "}
                  {ContainerPrice.sender_city?.name || ""}{" "}
                </td>
                <td>
                  {ContainerPrice.reciever_country?.name || ""}{" "}
                  {ContainerPrice.reciever_city?.name || ""}{" "}
                </td>

                <td>
                  {ContainerPrice.type_id === 0
                    ? ContainerPrice.frast_price +
                      ContainerPrice.thc_price +
                      +ContainerPrice.other_price
                    : ContainerPrice.total_price +
                      ContainerPrice.other_price}{" "}
                  $
                </td>

                <td>
                  {ContainerPrice.type_id === 0
                    ? ContainerPrice.client_frast_price +
                      ContainerPrice.client_thc_price +
                      +ContainerPrice.client_other_price
                    : ContainerPrice.client_total_price +
                      ContainerPrice.client_other_price}{" "}
                  $
                </td>

                <td>{ContainerPrice.agent?.name}</td>

                <td> {formatDate(ContainerPrice.period_start_at)}</td>
                <td> {formatDate(ContainerPrice.period_end_at)}</td>

                <td> {formatDate(ContainerPrice.created_at)}</td>
                <td> {formatDate(ContainerPrice.update_at)}</td>

                <td className={cl.btntbl}>
                  <div className={cl.btns}>
                    {app.hasPermission("CONTAINER_PRICE_EDIT") && (
                      <>
                        <Active
                          ContainerPriceService={ContainerPriceService}
                          defaultContainerPrice={ContainerPrice}
                        />
                        <ContainerPriceEditModal
                          ContainerPriceService={ContainerPriceService}
                          defaultContainerPrice={ContainerPrice}
                        />
                        <ContainerPriceDeleteModal
                          ContainerPriceService={ContainerPriceService}
                          defaultContainerPrice={ContainerPrice}
                        />
                      </>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Modal
        size="small"
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      >
        <div className={cl.modalHead}>
          <h3>
            <span className={cl.iconHead}>
              <Plus />
            </span>{' '}
            დამატება
          </h3>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div
            id="dynamicInputs"
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginTop: '15px',
            }}
          >
            {/* Initial empty input for new entries */}
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
              <span className="input-number" style={{ marginRight: '10px', fontSize: '14px', color: '#333' }}>
                1.
              </span>
              <input
                type="text"
                placeholder="კონტეინერის ნომერი"
                style={{
                  width: '180px',
                  padding: '10px',
                  fontSize: '14px',
                  border: '1px solid #ccc',
                  borderRadius: '5px'
                }}
              />
              <button
                style={{
                  marginLeft: '10px',
                  padding: '5px 10px',
                  backgroundColor: '#ff4444',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                }}
                onClick={(e) => {
                  const container = document.getElementById('dynamicInputs');
                  if (container.childElementCount > 1) {
                    e.currentTarget.parentElement.remove();
                    renumberInputs();
                  } else {
                    app.setError('მინიმუმ ერთი ველი უნდა დარჩეს!');
                  }
                }}
              >
                -
              </button>
            </div>
          </div>

          <button
            style={{
              marginTop: '15px',
              padding: '10px 20px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              alignSelf: 'flex-start',
            }}
            onClick={() => {
              const container = document.getElementById('dynamicInputs');
              const wrapper = document.createElement('div');
              wrapper.style = `
                display: flex;
                align-items: center;
                margin-bottom: 15px;
              `;

              const label = document.createElement('span');
              label.className = 'input-number';
              label.style = `
                margin-right: 10px;
                font-size: 14px;
                color: #333;
              `;

              const input = document.createElement('input');
              input.type = 'text';
              input.placeholder = 'კონტეინერის ნომერი';
              input.style = `
                width: 180px;
                padding: 10px;
                font-size: 14px;
                border: 1px solid #ccc;
                border-radius: 5px;
              `;

              const removeButton = document.createElement('button');
              removeButton.textContent = '-';
              removeButton.style = `
                margin-left: 10px;
                padding: 5px 10px;
                background-color: #ff4444;
                color: white;
                border: none;
                border-radius: 5px;
                cursor: pointer;
              `;
              removeButton.onclick = (e) => {
                const container = document.getElementById('dynamicInputs');
                if (container.childElementCount > 1) {
                  e.currentTarget.parentElement.remove();
                  renumberInputs();
                } else {
                  app.setError('მინიმუმ ერთი ველი უნდა დარჩეს!');
                }
              };

              wrapper.appendChild(label);
              wrapper.appendChild(input);
              wrapper.appendChild(removeButton);
              container.appendChild(wrapper);
              
              renumberInputs();
            }}
          >
            + დაამატე ახალი
          </button>

          {existingContainerIds && existingContainerIds.length > 0 && (
            <div style={{ marginTop: '20px' }}>
              <h4 style={{ 
                marginBottom: '10px',
                fontSize: '14px',
                color: '#333',
                fontWeight: '500'
              }}>
                არსებული კონტეინერები:
              </h4>
              {existingContainerIds.map((item, index) => (
                <div 
                  key={index}
                  style={{
                    marginBottom: '5px',
                    fontSize: '16px',
                    color: '#666',
                    padding: '5px',
                    backgroundColor: '#f5f5f5',
                    borderRadius: '4px'
                  }}
                >
                  <span style={{marginRight:'10px'}}>{index + 1}.</span>{item.id}
                </div>
              ))}
            </div>
          )}
        </div>

        <span
          onClick={saveContainerIds}
          className={cl.btnPrimary}
          style={{ marginTop: '20px', display: 'block' }}
        >
          გადატანა
        </span>
      </Modal>

      {appState.error && (
        <ErrorModal
          message={appState.error}
          onClose={() => app.clearError(false)}
        />
      )}

      <Pagination
        total={ContainerPriceService.total}
        perPage={ContainerPriceService.filter.limit}
        current={ContainerPriceService.filter.page}
        paginate={(page) => {
          ContainerPriceService.setFilter({
            ...ContainerPriceService.filter,
            page: page,
          });
        }}
        setLimit={(limit) => {
          ContainerPriceService.setFilter({
            ...ContainerPriceService.filter,
            limit: limit,
          });
        }}
      />
    </div>
  );
};

export default ContainerPriceList;
